<template>
  <div class="row new-request-section">
    <div>
      <span>Não encontrou o que está procurando?</span>
      <router-link :to="{ name: 'Form' }"
        ><br />
        <button type="button">ENVIE SUA SOLICITAÇÃO</button>
      </router-link>
    </div>
    <template v-if="telefone && atendimento">
      <p>Se preferir ligue para</p>
      <p>
        <a href>{{ telefone }}</a>
      </p>
      <div class="info">
        <p><strong>Central de atendimento: </strong>{{ atendimento }}</p>
        <p v-if="chat"><strong>Chat: </strong>{{ chat }}</p>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.new-request-section {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 50px;
}
.new-request-section .info p {
  text-align: center;
}
.new-request-section > div:first-child {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.new-request-section > div > span {
  color: rgba(0, 0, 0, 1);
  font-size: 12px;
}

.new-request-section > div button {
  min-width: 205px;
  color: #ffffff;
  font-size: 13px;
  border: none;
  border-radius: 0;
  background-color: rgba(0, 0, 0, 1);
  text-transform: uppercase;
  padding: 10px 15px;
  transition: background 300ms ease;
}

.new-request-section button:hover,
.new-request-section button:focus,
.new-request-section button:active {
  background-color: #333;
  cursor: pointer;
}

.new-request-section p {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
}

.new-request-section p:nth-child(3) > a {
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  text-align: center;
  font-weight: 400;
  text-decoration: none;
}

.new-request-section p:nth-child(3) > a:hover {
  text-decoration: underline;
}

@media (max-width: 560px) {
  .new-request-section > div:first-child {
    flex-direction: column !important;
    justify-content: center !important;
  }
}
</style>
<script>
export default {
  name: "RequestSection",
  props: {
    telefone: String,
    chat: String,
    atendimento: String,
  },
};
</script>
